/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { RecentlyViewedItem } from './recently-viewed-item';

/**
 * Represents a product for comparison.
 */
export class RecentlyViewedProductItem extends RecentlyViewedItem<string> {
    public readonly productId: number;

    public readonly catalogId: number;

    public static getItemId(productId: number, catalogId: number): string {
        return `${productId}-${catalogId}`;
    }

    public constructor(productId: number, catalogId: number) {
        const itemId = RecentlyViewedProductItem.getItemId(productId, catalogId);
        super(itemId);

        this.productId = productId;
        this.catalogId = catalogId;
    }
}
